import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BuyerIcon from '@/app/assets/icons/buyer.svg?react';
import SupplierIcon from '@/app/assets/icons/supplier.svg?react';
import FactorIcon from '@/app/assets/icons/factor.svg?react';

const didoxUrl = import.meta.env.VITE_DIDOX_BASE_URL ?? 'https://didox.uz';
const origin = window.location.origin;

const LandingHero = () => {
  const { t } = useTranslation('landing');

  const features = [
    {
      Image: SupplierIcon,
      title: t('features.0.title'),
      subtitle: t('features.0.subtitle'),
    },
    {
      Image: BuyerIcon,
      title: t('features.1.title'),
      subtitle: t('features.1.subtitle'),
    },
    {
      Image: FactorIcon,
      title: t('features.2.title'),
      subtitle: t('features.2.subtitle'),
    },
  ];

  return (
    <Stack alignItems='center' mt={12.5} mb={18.5}>
      <Typography
        variant='h1'
        textAlign='center'
        fontSize='34px'
        fontWeight={500}
        lineHeight={1.7}
      >
        {t('title')}
      </Typography>

      <Typography
        variant='h2'
        textAlign='center'
        fontSize='24px'
        fontWeight={400}
        lineHeight={1.7}
      >
        {t('subtitle')}
      </Typography>

      <Stack spacing={2} mt={4}>
        <Box
          component='a'
          sx={{
            display: 'block',
          }}
          href={`${didoxUrl}/login_with_signature?r=${origin}/auth/seller`}
        >
          <Button size='large' sx={{ fontWeight: '600' }}>
            {t('i_am_buyer')}
          </Button>
        </Box>

        <Button
          LinkComponent={Link}
          href={`${didoxUrl}/login_with_signature?r=${origin}/auth/factor`}
          size='large'
          color='inherit'
          sx={{ fontWeight: '600', border: '1px solid #0B13701A' }}
        >
          {t('i_am_factor')}
        </Button>
      </Stack>

      <Stack
        mt={8}
        direction='row'
        gap={3}
        flexWrap='wrap'
        justifyContent='center'
      >
        {features.map((feature, idx) => (
          <Box
            key={idx}
            sx={{
              background: '#FFFFFF',
              borderRadius: '16px',
              padding: '24px',
              maxWidth: 320,
            }}
          >
            <Box component={feature.Image} />

            <Typography
              variant='body2'
              sx={{
                fontWeight: 600,
                fontSize: '14px',
                margin: ' 24px 0 10px',
                lineHeight: 1.5,
              }}
            >
              {feature.title}
            </Typography>

            <Typography
              variant='h4'
              sx={{
                fontWeight: 400,
                fontSize: '13px',
                lineHeight: 1.5,
              }}
            >
              {feature.subtitle}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default LandingHero;
